import {useTranslation} from "react-i18next";
import {CargoSubtype, containerLevelHistoryTypes, ContainerStatusEntity} from "@ots-frontend/ots-data";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {InsightContainer} from "../InsightContainer/InsightContainer";
import {ContainerStatusDataTable} from "../../data-table/ContainerStatusDataTable/ContainerStatusDataTable";
import {useMemo} from "react";

export type HighNonPrimaryVolumeContainersInsightProps =
  Omit<InsightChartContainerProps, 'children' | 'title' | 'icon'>
  & {
  cargoSubtype: CargoSubtype
  value?: ContainerStatusEntity[]
  loading?: boolean
}

export const HighNonPrimaryVolumeContainersInsight = (props: HighNonPrimaryVolumeContainersInsightProps) => {
  const {cargoSubtype, value, loading = false, ...rest} = props

  const {t} = useTranslation()

  const title = useMemo(() => {
    return t("common.insight.highnonprimaryvolumecontainers", "High Bottoms Levels")
  }, [t])

  if (!value || value.length === 0) {
    return (
      <InsightEmpty {...rest} title={title}/>
    )
  }

  return (
    <InsightContainer
      {...rest}
      title={title}
      icon={"chartHistogram"}>
      <ContainerStatusDataTable
        mt={25}
        withBorder
        records={value}
        recordsPerPageOptions={[5]}
        fetching={loading}
        getHeightValue={(status) => status.getFill(cargoSubtype, containerLevelHistoryTypes.meter)?.actualHeight}
        columns={{
          level: true,
          fill: true,
        }}/>
    </InsightContainer>
  )
}
